/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
import _Array$isArray from"@babel/runtime-corejs3/core-js-stable/array/is-array";const isArray=_Array$isArray||function(r){return"[object Array]"===Object.prototype.toString.call(r)};export default isArray;